export const DEFAULT_EXPIRATION = 15;

export const startExpirationTimer = (
    onExpire,
    expirationHour = DEFAULT_EXPIRATION,
    now = new Date()
) => {
    const expirationTime = new Date();
    expirationTime.setHours(expirationHour, 0, 0, 0);
    if (expirationTime < now) {
        expirationTime.setDate(expirationTime.getDate() + 1);
    }
    const remainingTime = expirationTime - now;
    setTimeout(onExpire, remainingTime);
};

export const makeExpirationDate = (nowParam) => {
    if (nowParam) {
        return nowParam;
    }
    const now = new Date();
    const expirationDate = new Date(now);
    expirationDate.setHours(DEFAULT_EXPIRATION, 0, 0, 0);
    if (expirationDate < now) {
        expirationDate.setDate(expirationDate.getDate() + 1);
    }
    return expirationDate.getTime();
};

export const hasItemExpired = (expireTime = 0, now = Date.now()) => expireTime <= now;

const areChannelsOutOfDate = (channels = [], now) =>
    channels.some(({ live }) => live && live.end < now);

export const haveChannelsExpired = (expireTime, { items } = {}, now = Date.now) =>
    hasItemExpired(expireTime, now) || areChannelsOutOfDate(items, now);
